<template>
  <section class="optimization-page">
    <div class="hero-panel" v-if="$route.query.campaign_type=='2'">
      <div class="hero-content">
        <h1>
          <span class="wave">&#128075;</span>
          {{ $t("OptWelcome", { name: user.user_name }) }}
        </h1>
        <p class="hero-subtitle">{{ $t("OptHeroSubtitle") }}</p>
        <p class="hero-copy">
          {{ $t("OptHeroCopy") }}
        </p>
        <p class="hero-subtitle" v-html="$t('OptHeroFlow')">
        </p>
        <p class="hero-copy">{{ $t("OptHeroTakeover") }}</p>
      </div>
    </div>
    <div class="hero-panel" v-if="$route.query.campaign_type=='1'">
      <div class="hero-content">
        <h1>
          <span class="wave">&#128075;</span>
          {{ $t("OptSaleWelcome", { name: user.user_name }) }}
        </h1>
        
        <p class="hero-copy">
         {{ $t("OptSaleCopy1") }}
        </p>
        <p class="hero-copy">
        {{ $t("OptSaleCopy2") }}
        </p>
        <p class="hero-copy">
        {{ $t("OptSaleCopy3") }}
        </p>
      </div>
    </div>

    <div class="info-grid" v-if="$route.query.campaign_type=='2'">
      <article  v-for="card in infoCards" :key="card.title" class="info-card">
        <div :class="['icon-box', card.iconClass]">{{ card.icon }}</div>
        <h2>{{ card.title }}</h2>
        <div class="summary-box">
          {{ card.content }}
        </div>
        <div v-if="card.badge" class="metric-badge">
          {{ card.badge }}
        </div>
      </article>
    </div>

    <div class="info-grid" v-if="$route.query.campaign_type=='1'">
      <article  v-for="card in saleCards" :key="card.title" class="info-card">
        <div :class="['icon-box', card.iconClass]">{{ card.icon }}</div>
        <h2>{{ card.title }}</h2>
        <div class="summary-box">
          {{ card.content }}
        </div>
        <div v-if="card.badge" class="metric-badge">
          {{ card.badge }}
        </div>
      </article>
    </div>

    <section class="action-card">
      <h2>{{ $t("OptActionTitle") }}</h2>
      <p>
        {{ $t("OptActionDesc") }}
      </p>
      <div class="action-row">
        <a-button
          size="large"
          class="action-btn primary"
          type="button"
          @click="handleWatchExample"
        >
          <span class="play-icon">&#9658;</span>
          {{ $t("OptWatchExample") }}
        </a-button>

        <a-button
          size="large"
          class="action-btn accent"
          type="button"
          @click="handleCreateCampaign"
        >
          {{ $t("OptCreateCampaign") }}
        </a-button>
        <a-tooltip placement="topLeft">
          <template slot="title">
            <span>{{ $t("OptStrategyTooltip") }}</span>
          </template>
          <a-button
            size="large"
            class="action-btn outline"
            type="button"
            @click="handleBuildStrategy"
            ><span class="strategy-icon">&#129658;</span>
            {{ $t("OptStrategyBtn") }}</a-button
          >
        </a-tooltip>
      </div>
    </section>
  </section>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Optimization",
  i18n: require("./indexi18n"),
  computed: {
    ...mapGetters("account", ["user"]),
  },
  data() {
    let that = this;
    return {
      fromPath: "",

      infoCards: [
        {
          icon: "🧠",
          iconClass: "mint",
          title: that.$t("OptCard1Title"),
          content: that.$t("OptCard1Content"),
        },
        {
          icon: "🎯",
          iconClass: "mint",
          title: that.$t("OptCard2Title"),
          content: that.$t("OptCard2Content"),
        },
        {
          icon: "📈",
          iconClass: "peach",
          title: that.$t("OptCard3Title"),
          content: that.$t("OptCard3Content"),
          badge: that.$t("OptCard3Badge"),
        },
      ],
       saleCards: [
        {
          icon: "🧠",
          iconClass: "mint",
          title: that.$t("OptCard1Title"),
          content: that.$t("OptSaleCard1Content"),
        },
        {
          icon: "🎯",
          iconClass: "mint",
          title: that.$t("OptCard2Title"),
          content: that.$t("OptSaleCard2Content"),
        },
        {
          icon: "📈",
          iconClass: "peach",
          title: that.$t("OptCard3Title"),
          content: that.$t("OptSaleCard3Content"),
          badge: that.$t("OptSaleCard3Badge"),
        },
      ],
    };
  },
  beforeRouteEnter(to, from, next) {
    try {
      // `setPost` 方法定义在下面的代码中
      next((vm) => {
        vm.fromPath = from.path;
      });
    } catch (err) {
      // `setError` 方法定义在下面的代码中
      next((vm) => vm.setError(err));
    }
  },
  methods: {
    handleWatchExample() {
      this.$router.push({
        path:this.$route.query.campaign_type=="1" ? "/guide/salesExample" : "/guide/recruiterExample",
        query: {
          ...this.$route.query,
        },
      });
    },
    handleCreateCampaign() {
      let { campaign_type } = this.$route.query;
      //   let { hr_campaign_created, sales_campaign_created } = this.user || {};
      this.writeLog(
        "consultation",
        campaign_type == "1" ? "sales" : "recruiter",
        "continue_consultation",
      );
      if (campaign_type == "1") {
        if (this.user.has_customer_info) {
          this.$router.push({
            path: "/sales/salesReps/createCampaign",
            query: { linkedin_id: "new" },
          });
        } else {
          this.$router.push({
            path: "/sales/salesReps/collectUserInfo",
            query: { linkedin_id: "new" },
          });
        }
      } else {
        if (this.user.has_customer_info) {
          this.$router.replace({
            path: "/hr/recruiter/createCampaign",
            query: { linkedin_id: "new" },
          });
        } else {
          this.$router.replace({
            path: "/hr/recruiter/collectUserInfo",
            query: { linkedin_id: "new" },
          });
        }
      }
    },
    handleBuildStrategy() {
      this.$router.push({
        path: "/consultation/enter",
        query: {
          ...this.$route.query,
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.optimization-page {
  min-height: 100%;
  padding: 28px;
  background: #f1f4f1;
  color: #101817;
  font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
}

.hero-panel {
  position: relative;
  overflow: hidden;
  border-radius: 22px;
  background: linear-gradient(120deg, #0f8f74, #0a5f4f);
  // background-size: 24px 24px, auto;
  box-shadow: 0 18px 38px rgba(9, 75, 62, 0.12);
}

.hero-content {
  padding: 26px 28px;
  color: #fff;

  h1 {
    margin: 0 0 12px;
    font-size: 24px;
    line-height: 1.18;
    font-weight: 800;
    letter-spacing: 0;
    color: #fff;
  }
}

.wave {
  display: inline-block;
  margin-right: 10px;
}

.hero-subtitle {
  margin: 0 0 14px;
  font-size: 16px;
  line-height: 1.3;
  font-weight: 750;
}

.hero-copy {
  margin: 0 0 12px;
  color: rgba(255, 255, 255, 0.76);
  font-size: 14px;
  line-height: 1.4;
}

.hero-flow {
  margin: 0 0 12px;
  color: #fff;
  font-size: 26px;
  line-height: 1.4;
  font-weight: 800;
}

.info-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 28px;
  margin-top: 34px;
}

.info-card,
.action-card {
  border: 1px solid #e2e7e3;
  border-radius: 18px;
  background: #fff;
  box-shadow: 0 10px 24px rgba(28, 43, 39, 0.06);
}

.info-card {
  // min-height: 390px;
  padding: 26px;

  h2 {
    margin: 18px 0 18px;
    color: #101817;
    font-size: 14px;
    line-height: 1.25;
    font-weight: 800;
    letter-spacing: 0;
  }
}

.icon-box {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 70px;
  height: 70px;
  border-radius: 14px;
  font-size: 28px;
}

.icon-box.mint {
  background: #e9f7f3;
}

.icon-box.peach {
  background: #fff0e8;
}

.summary-box {
  // min-height: 124px;
  padding: 22px;
  border: 1px solid #d5e6df;
  border-radius: 12px;
  background: #e8f4f1;
  color: #0a5f4f;
  font-size: 14px;
  line-height: 1.45;
  font-weight: 700;
}

.metric-badge {
  display: inline-flex;
  align-items: center;
  max-width: 100%;
  min-height: 50px;
  margin-top: 16px;
  padding: 0 16px;
  border-radius: 8px;
  background: #e7f3f0;
  color: #0a5f4f;
  font-size: 14px;
  line-height: 1.3;
  font-weight: 700;
}

.action-card {
  margin-top: 34px;
  padding: 38px 32px;

  h2 {
    margin: 0 0 14px;
    color: #101817;
    font-size: 14px;
    line-height: 1.25;
    font-weight: 800;
    letter-spacing: 0;
  }

  p {
    margin: 0;
    color: #7b867f;
    font-size: 13px;
    line-height: 1.45;
  }
}

.action-row {
  display: flex;
  align-items: center;
  gap: 20px;
  margin-top: 34px;
}

.action-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  // min-height: 80px;
  padding: 24px 24px;
  font-size: 14px;
  border-radius: 11px;
  border: 1px solid transparent;
  font-size: 14px;
  border-radius: 11px;
  line-height: 1.25;
  font-weight: 800;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 10px 22px rgba(22, 37, 33, 0.12);
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 3px rgba(5, 128, 103, 0.22);
  }
}

.action-btn.primary {
  // min-width: 445px;
  background: #078a72;
  color: #fff;
}

.action-btn.accent {
  // min-width: 320px;
  background: #f26122;
  color: #fff;
}

.action-btn.outline {
  // flex: 1;
  // min-width: 420px;
  border-color: #dfe4e2;
  background: #fff;
  color: #3a4042;
}

.play-icon,
.strategy-icon {
  margin-right: 10px;
  font-size: 18px;
}

// @media (max-width: 1400px) {
//     .hero-content h1 {
//         font-size: 34px;
//     }

//     .hero-subtitle {
//         font-size: 25px;
//     }

//     .hero-copy,
//     .hero-flow,
//     .summary-box {
//         font-size: 22px;
//     }

//     .action-btn {
//         font-size: 20px;
//     }
// }

// @media (max-width: 1100px) {
//     .info-grid {
//         grid-template-columns: 1fr;
//     }

//     .info-card {
//         min-height: 0;
//     }

//     .action-row {
//         flex-wrap: wrap;
//     }

//     .action-btn.primary,
//     .action-btn.accent,
//     .action-btn.outline {
//         flex: 1 1 320px;
//         min-width: 0;
//     }
// }

// @media (max-width: 640px) {
//     .optimization-page {
//         padding: 16px;
//     }

//     .hero-panel {
//         min-height: 0;
//         border-radius: 16px;
//     }

//     .hero-content {
//         padding: 30px 22px;

//         h1 {
//             margin-bottom: 24px;
//             font-size: 28px;
//         }
//     }

//     .hero-subtitle {
//         font-size: 22px;
//     }

//     .hero-copy,
//     .hero-flow,
//     .summary-box {
//         font-size: 18px;
//     }

//     .info-grid,
//     .action-card {
//         margin-top: 20px;
//     }

//     .info-card,
//     .action-card {
//         border-radius: 14px;
//         padding: 22px;
//     }

//     .info-card h2,
//     .action-card h2 {
//         font-size: 22px;
//     }

//     .action-card p,
//     .metric-badge {
//         font-size: 16px;
//     }

//     .action-row {
//         gap: 12px;
//         margin-top: 24px;
//     }

//     .action-btn {
//         width: 100%;
//         min-height: 60px;
//         padding: 0 18px;
//         font-size: 17px;
//     }
// }
</style>
